import type { Module, StableId } from "@archlang/scene/arch-model";

export function mergeModules(
  before: readonly Module[],
  after: readonly Module[],
): readonly Module[] {
  const beforeById = new Map<StableId, Module>();
  for (const m of before) if (m.id) beforeById.set(m.id, m);
  const afterById = new Map<StableId, Module>();
  for (const m of after) if (m.id) afterById.set(m.id, m);

  // Union ids, before's order first (removed nodes keep their slot), then
  // after-only appended.
  const order: StableId[] = [];
  const seen = new Set<StableId>();
  const pushId = (id: StableId | undefined): void => {
    if (id && !seen.has(id)) {
      seen.add(id);
      order.push(id);
    }
  };
  for (const m of before) pushId(m.id);
  for (const m of after) pushId(m.id);

  return order.map((id) => {
    const a = afterById.get(id);
    const b = beforeById.get(id);
    // Present on both: after wins for the node's own content, but RECURSE so a
    // child that exists only in `before` (a removed nested module) survives
    // under the surviving parent instead of being dropped with its subtree. A
    // one-sided node is entirely added or entirely removed — keep its subtree.
    if (a && b) return { ...a, children: mergeModules(b.children, a.children) };
    return (a ?? b)!;
  });
}
